const holdMs = 5000;
type End = "enviar" | "desfazer";

export function createHolds(after: (ms: number, run: () => void) => () => void) {
  const holds = new Map<string, { readonly stop: () => void; readonly end: (how: End) => void }>();
  const end = (requestKey: string, how: End): boolean => {
    const hold = holds.get(requestKey);
    holds.delete(requestKey);
    hold?.stop();
    hold?.end(how);
    return hold !== undefined;
  };
  return {
    hold(requestKey: string, ends: (how: End) => void): void {
      holds.set(requestKey, { stop: after(holdMs, () => end(requestKey, "enviar")), end: ends });
    },
    end,
    every: (how: End) => [...holds.keys()].forEach((requestKey) => end(requestKey, how)),
  };
}
